<div class="container">
    <mat-card>
        <h2 mat-title>Reportes</h2>
        <form [formGroup]="tellerReportsForm" (ngSubmit)="submit()">
            <mat-card-content fxLayout="column">
                
                <mat-form-field>
                    <mat-label>Reporte</mat-label>
                    <mat-select formControlName="reportType" (selectionChange)="onReportTypeChange($event.value)" required>
                        <mat-option *ngFor="let opt of reportTypeOptions" [value]="opt.value">
                            {{ opt.displayName }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="tellerReportsForm.controls.reportType.hasError('required')">
                        Reporte es <strong>obligatorio</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="48%" (click)="cashDatePicker.open()" *ngIf="tellerReportsForm.controls['asOn']" >
                    <mat-label>Fecha</mat-label>
                    <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="cashDatePicker" required
                        formControlName="asOn">
                    <mat-datepicker-toggle matSuffix [for]="cashDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #cashDatePicker></mat-datepicker>                   
                    <mat-error *ngIf="tellerReportsForm.controls.asOn.hasError('required')">
                        Fecha <strong>es obligatoria</strong>
                    </mat-error>                    
                </mat-form-field>               
                <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
                    <button type="button" mat-raised-button [routerLink]="['/home']">Cancelar</button>
                    <button mat-raised-button color="primary" [disabled]="!tellerReportsForm.valid">Generar</button>
                </mat-card-actions>
            </mat-card-content>
        </form>
    </mat-card>
</div>
